import { lazy } from 'react';

export const AffiliateReferralDetailPageLazy = lazy(
    () => import('./affiliate-referral-detail-page'),
);
